function Search() {
  return (
    <div class="searchbar">
      <input type="text" placeholder="Search" />
    </div>
  )
}

export default Search